(function() {
  'use strict';

  angular.module('eclipseApp').config([
    'ute.datalayer.common.serviceProvider',
    function(dataLayerServiceProvider) {
      var config;
      var selfServeAccountRegistrationName = 'account registration';
      var accountRegistrationHierarchy = ['myaccount', 'registration'];
      var myAccountHierarchy = ['myaccount'];
      var selfServeAccountRegistration = {
        name: selfServeAccountRegistrationName,
        type: 'transaction'
      };

      var selfServeSubscriber = {
        name: 'subscriber registration',
        type: 'transaction'
      };

      var contactOnlineBillingEmail; //Added in order to capture email for online billing selfServeComplete
      var creditCardInfoRequest; //Added in order to capture credit card type

      function getPayload(key) {
        var payload = {};
        var mappingKeys = key.split(',');
        _.forEach(mappingKeys, function(mappingKey) {
          mappingKey = _.trim(mappingKey);
          if (_.has(config.advance.mappingKey, mappingKey)) {
            _.merge(payload, _.cloneDeep(_.get(config.advance.mappingKey, mappingKey)));
          }
        });
        return payload;
      }

      config = {
        basic: {
          site: {
            name: 'F'
          }
        },
        advance: {
          //---------------------------------------
          // About the 'configOptions' property:
          //
          // - Indicate whether you'd like to load the configuration from the file specified in 'pathToConfigFile'.
          // - If the configuration file is not specified, the locally defined configuration mapping will be used instead.
          //---------------------------------------
          configOptions: {
            rootHierarchy: ['internet'], //Default Page Hierarchy - one or multiple level(s) (See FSD v5.1 pg. 19)
            pathToConfigFile: 'resource/dataLayerConfig.json', //path to the configuration file
            loadFromFile: false, //'true' to load configuration from a file, 'false' otherwise
            isAbsolutePath: false, //'true' if pathToConfigFile is a full URL (i.e. a CMS http link), 'false' otherwise.
            globalTrackingOn: true, //flag to specify if global tracking should be enabled
            globalTrackingExclusive: true //global tracking will fire only for state names that are defined in mappingKey.
          },

          mappingKey: {
            login: {},
            invoice: {
              viewInvoice: {
                interaction: {
                  type: 'show',
                  name: 'subscriber profile:view bill message'
                },
                events: {
                  interaction: true
                }
              }
            },
            paymentMethod: {
              page: {
                page: {
                  hierarchy: ['myaccount', 'payment-method'],
                  url: 'modal popup'
                }
              },
              changePaymentStart: {
                page: {
                  name: 'pre auth payment:change method of payment'
                }
              },
              cancel: {
                selfServe: {
                  selfServe: {
                    name: 'cancel pre auth payment',
                    type: 'transaction'
                  }
                },
                start: {
                  page: {
                    name: 'pre auth payment:cancel flow start'
                  },
                  events: {
                    selfServeStart: true
                  }
                },
                complete: {
                  page: {
                    name: 'pre auth payment:cancel flow success'
                  },
                  events: {
                    selfServeComplete: true
                  }
                }
              },
              error: {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'payment-method']
                }
              },
              creditCard: {
                selfServe: {
                  selfServe: {
                    name: 'pre auth payment-credit card',
                    type: 'transaction'
                  }
                },
                error: {
                  page: {
                    name: 'pre auth payment:add credit card'
                  }
                },
                start: {
                  page: {
                    name: 'pre auth payment:add credit card'
                  },
                  events: {
                    selfServeStart: true
                  }
                },
                review: {
                  page: {
                    name: 'pre auth payment:review credit card'
                  }
                },
                complete: {
                  page: {
                    name: 'pre auth payment:success credit card'
                  },
                  events: {
                    selfServeComplete: true
                  }
                }
              },
              bank: {
                error: {
                  page: {
                    name: 'pre auth payment:add bank account'
                  }
                },
                termsError: {
                  page: {
                    name: 'pre auth payment:terms and conditions'
                  }
                },
                selfServe: {
                  selfServe: {
                    name: 'pre auth payment-bank account',
                    type: 'transaction'
                  }
                },
                start: {
                  page: {
                    name: 'pre auth payment:add bank account'
                  },
                  events: {
                    selfServeStart: true
                  }
                },
                terms: {
                  page: {
                    name: 'pre auth payment:terms and conditions'
                  }
                },
                complete: {
                  page: {
                    name: 'pre auth payment:success bank account'
                  },
                  events: {
                    selfServeComplete: true
                  }
                }
              },
              preauthStart: {
                page: {
                  name: 'pre auth payment:set up auto pay'
                }
              }
            },
            accOverviewLoadingAPIError: {
              page: {
                name: 'overview',
                hierarchy: myAccountHierarchy
              }
            },
            onboarding: {
              widget: {
                events: {
                  interaction: true
                },
                interaction: {
                  type: 'show',
                  name: 'onboarding widget'
                }
              },
              setRecoveryNumber: {
                learnMore: {
                  events: {
                    interaction: true
                  },
                  interaction: {
                    type: 'click',
                    name: 'support article-wirelessrecovery number'
                  }
                },
                step1: {
                  page: {
                    name: 'modal-wireless recovery',
                    hierarchy: ['myaccount', 'wireless recovery'],
                    url: 'modal popup'
                  },
                  events: {
                    interaction: true,
                    pageView: true
                  },
                  interaction: {
                    type: 'click',
                    name: 'wireless recovery onboarding step 1'
                  }
                },
                step2: {
                  events: {
                    interaction: true
                  },
                  interaction: {
                    type: 'click',
                    name: 'wireless recovery onboarding step 2'
                  }
                }
              },
              setOnlineBilling: {
                step1: {
                  page: {
                    name: 'modal-online billing',
                    hierarchy: ['myaccount', 'online billing'],
                    url: 'modal popup'
                  },
                  events: {
                    interaction: true,
                    pageView: true
                  },
                  interaction: {
                    type: 'click',
                    name: 'online billing onboarding step 1'
                  }
                },
                step2: {
                  events: {
                    interaction: true
                  },
                  interaction: {
                    type: 'click',
                    name: 'online billing onboarding step 2'
                  }
                }
              },
              setAutoPayment: {
                step1: {
                  page: {
                    name: 'modal-pre-authorized payments',
                    hierarchy: ['myaccount', 'pre-authorized payments'],
                    url: 'modal popup'
                  },
                  events: {
                    interaction: true,
                    pageView: true
                  },
                  interaction: {
                    type: 'click',
                    name: 'pre-authorized payments onboarding step 1'
                  }
                },
                step2: {
                  events: {
                    interaction: true
                  },
                  interaction: {
                    type: 'click',
                    name: 'pre-authorized payments onboarding step 2'
                  }
                }
              },
              verifyContactEmail: {
                step1: {
                  page: {
                    name: 'modal-verify email step 1',
                    hierarchy: ['myaccount', 'verify email'],
                    url: 'modal popup'
                  },
                  events: {
                    selfServeStart: true,
                    pageView: true
                  },
                  selfServe: {
                    type: 'transaction',
                    name: 'onboarding verify email'
                  }
                },
                emailVerified: {
                  page: {
                    name: 'modal-verify email confirmation',
                    hierarchy: ['myaccount', 'verify email']
                  },
                  events: {
                    selfServeComplete: true,
                    pageView: true
                  },
                  selfServe: {
                    type: 'transaction',
                    name: 'onboarding verify email'
                  }
                },
                editEmail: {
                  step1: {
                    page: {
                      name: 'modal-edit email step 1',
                      hierarchy: ['myaccount', 'verify email']
                    },
                    events: {
                      selfServeStart: true,
                      pageView: true
                    },
                    selfServe: {
                      type: 'transaction',
                      name: 'onboarding update email'
                    }
                  },
                  step2: {
                    page: {
                      name: 'modal-edit email step 2',
                      hierarchy: ['myaccount', 'verify email']
                    },
                    events: {
                      pageView: true
                    }
                  },
                  emailChanged: {
                    page: {
                      name: 'modal-edit email confirmation',
                      hierarchy: ['myaccount', 'verify email']
                    },
                    events: {
                      selfServeComplete: true
                    },
                    selfServe: {
                      type: 'transaction',
                      name: 'onboarding update email'
                    }
                  }
                }
              },
              addContactEmail: {
                step1: {
                  page: {
                    name: 'modal-add email step 1',
                    hierarchy: ['myaccount', 'add email'],
                    url: 'modal popup'
                  },
                  events: {
                    selfServeStart: true,
                    pageView: true
                  },
                  selfServe: {
                    type: 'transaction',
                    name: 'onboarding add email'
                  }
                },
                step2: {
                  page: {
                    name: 'modal-add email step 2',
                    hierarchy: ['myaccount', 'add email'],
                    url: 'modal popup'
                  },
                  events: {
                    pageView: true
                  }
                },
                emailAdded: {
                  page: {
                    name: 'modal-add email confirmation',
                    hierarchy: ['myaccount', 'add email'],
                    url: 'modal popup'
                  },
                  events: {
                    selfServeComplete: true,
                    pageView: true
                  },
                  selfServe: {
                    type: 'transaction',
                    name: 'onboarding add email'
                  }
                }
              },
              onboardingCompleted: {
                events: {
                  interaction: true
                },
                interaction: {
                  type: 'show',
                  name: 'onboarding completion message'
                }
              }
            },
            setPassword: {
              suppressTracking: true
            },
            setPasswordExpired: {
              page: {
                name: 'sms auto reg:sms link exp',
                hierarchy: accountRegistrationHierarchy
              },
              selfServe: {
                name: 'sms auto registration',
                type: 'transaction'
              }
            },
            setPasswordSuccess: {
              page: {
                name: 'sms auto reg:success',
                hierarchy: accountRegistrationHierarchy
              },
              selfServe: {
                name: 'sms auto registration',
                type: 'transaction'
              },
              events: {
                selfServeComplete: true
              }
            },
            autoReg: {
              username: {
                start: {
                  selfServe: {
                    name: 'sms auto reg-change username',
                    type: 'transaction'
                  },
                  events: {
                    selfServeStart: true
                  }
                },
                complete: {
                  selfServe: {
                    name: 'sms auto reg-change username',
                    type: 'transaction'
                  },
                  events: {
                    selfServeComplete: true
                  }
                }
              },
              resendSms: {
                start: {
                  selfServe: {
                    name: 'sms auto reg-resend link',
                    type: 'inquiry'
                  },
                  events: {
                    selfServeComplete: true
                  }
                },
                error: {
                  page: {
                    name: 'sms auto reg:sms link exp',
                    hierarchy: accountRegistrationHierarchy
                  }
                }
              },
              error: {
                page: {
                  name: 'sms auto reg:set password',
                  hierarchy: accountRegistrationHierarchy
                }
              },
              errorPage: {
                page: {
                  name: 'sms auto reg:error page',
                  hierarchy: accountRegistrationHierarchy
                },
                events: {
                  pageView: true,
                  error: true
                }
              },
              setPasswordPage: {
                page: {
                  name: 'sms auto reg:set password',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: {
                  name: 'sms auto registration',
                  type: 'transaction'
                },
                events: {
                  selfServeStart: true,
                  pageView: true
                }
              },
              setPasswordModal: {
                events: {
                  pageView: true,
                  selfServeStart: true
                },
                page: {
                  hierarchy: ['myaccount', 'registration'],
                  name: 'email auto reg:set password modal',
                  url: 'modal popup'
                },
                selfServe: {
                  name: 'email auto registration',
                  type: 'transaction'
                }
              },
              setPasswordButtonFinish: {
                events: {
                  selfServeComplete: true
                },
                selfServe: {
                  name: 'email auto registration',
                  type: 'transaction'
                }
              },
              resendLinkModal: {
                events: {
                  pageView: true
                },
                page: {
                  hierarchy: ['myaccount', 'registration'],
                  name: 'email auto reg:link expired',
                  url: 'modal popup'
                },
                selfServe: {
                  name: 'email auto registration',
                  type: 'transaction'
                }
              },
              resendLinkButton: {
                interaction: {
                  type: 'click',
                  name: 'email auto reg:resend link'
                },
                events: {
                  interaction: true
                }
              }
            },
            addToCalendar: {
              open: {
                interaction: {
                  type: 'open',
                  name: 'add to calendar'
                },
                events: {
                  interaction: true
                },
                page: {
                  name: 'overview',
                  hierarchy: myAccountHierarchy
                }
              },
              complete: {
                events: {
                  selfServeComplete: true
                },
                page: {
                  name: 'overview',
                  hierarchy: myAccountHierarchy
                }
              }
            },
            //--------------------------------------
            //        EASY LOGIN KEYS
            //--------------------------------------
            accountRegistration: {
              main: {
                page: {
                  name: 'registration main',
                  hierarchy: accountRegistrationHierarchy
                }
              },
              account: {
                page: {
                  name: 'account registration step1 account',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeAccountRegistration,
                events: {
                  selfServeStart: true
                }
              },
              email: {
                page: {
                  name: 'account registration step2 email',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeAccountRegistration
              },
              resendEmail: {
                page: {
                  name: 'account registration step3 verify',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: {
                  name: 'account registration - resend email',
                  type: 'inquiry'
                }
              },
              verify: {
                page: {
                  name: 'account registration step3 verify',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeAccountRegistration
              },
              password: {
                page: {
                  name: 'account registration step4 password',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeAccountRegistration
              },
              great_news: {
                page: {
                  name: 'account registration resume great news',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeAccountRegistration
              },
              great_news_verify: {
                page: {
                  name: 'account registration resume verify',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeAccountRegistration
              },
              complete: {
                page: {
                  name: 'account registration step5 complete',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeAccountRegistration,
                events: {
                  selfServeComplete: true
                }
              }
            },
            subscriberRegistration: {
              number: {
                page: {
                  name: 'subscriber registration step1 number',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeSubscriber,
                events: {
                  selfServeStart: true
                }
              },
              verify_sms: {
                page: {
                  name: 'subscriber registration step2 number verify',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeSubscriber
              },
              email: {
                page: {
                  name: 'subscriber registration step3 email',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeSubscriber
              },
              verify: {
                page: {
                  name: 'subscriber registration step4 email verify',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeSubscriber
              },
              resendEmail: {
                page: {
                  name: 'subscriber registration step4 email verify',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: {
                  name: 'subscriber registration - resend email',
                  type: 'inquiry'
                }
              },
              resend_sms: {
                page: {
                  name: 'subscriber registration step2 number verify',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: {
                  name: 'subscriber registration - resend code',
                  type: 'inquiry'
                }
              },
              password: {
                page: {
                  name: 'subscriber registration step5 password',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeSubscriber
              },
              complete: {
                page: {
                  name: 'subscriber registration step6 complete',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeSubscriber,
                events: {
                  selfServeComplete: true
                }
              },
              great_news: {
                page: {
                  name: 'subscriber registration resume great news',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeSubscriber
              },
              great_news_verify: {
                page: {
                  name: 'subscriber registration resume verify',
                  hierarchy: accountRegistrationHierarchy
                },
                selfServe: selfServeSubscriber
              }
            },
            //--------------------------------------------
            //        MY ACCOUNT SELF-SERVE SHARED KEYS
            //--------------------------------------------
            event: {
              selfServeStart: {
                events: {
                  selfServeStart: true
                }
              },
              selfServeComplete: {
                events: {
                  selfServeComplete: true
                }
              },
              pageView: {
                events: {
                  pageView: true
                }
              }
            },
            //--------------------------------------------
            //        MY ACCOUNT SELF-SERVE KEYS
            //--------------------------------------------
            'reactivate-device': {
              selfServe: {
                name: 'myaccount reactivate device',
                type: 'transaction'
              }
            },
            'internet-daily-usage': {
              selfServe: {
                name: 'pasv-myaccount-view internet daily usage',
                type: 'inquiry'
              }
            },
            'internet-usage-monthly': {
              selfServe: {
                name: 'pasv-myaccount-view internet monthly usage',
                type: 'inquiry'
              }
            },
            'internet-usage-alerts': {
              selfServe: {
                name: 'pasv-myaccount-view internet usage alerts',
                type: 'inquiry'
              }
            },
            'prepaid-registration': {
              selfServe: {
                name: 'actv-myfido-account registration',
                type: 'transaction'
              }
            },
            'change-payment-method-invoice': {
              selfServe: {
                name: 'actv-myfido-update method of payment',
                type: 'transaction'
              },
              ecommerce: {
                paymentMethods: ['manual']
              }
            },
            'change-payment-method': {
              selfServe: {
                name: 'actv-myfido-update method of payment',
                type: 'transaction'
              },
              ecommerce: {
                paymentMethods: null
              }
            },
            'update-sim-card': {
              selfServe: {
                name: 'actv-myfido-Update SIM Card',
                type: 'transaction'
              }
            },
            'unlink-facebook': {
              selfServe: {
                name: 'actv-myfido-unlink facebook account',
                type: 'transaction'
              }
            },
            'link-facebook': {
              selfServe: {
                name: 'actv-myfido-link facebook account',
                type: 'transaction'
              }
            },
            'lost-stolen-device': {
              selfServe: {
                name: 'actv-myfido-report lost device',
                type: 'transaction'
              }
            },
            'change-billing-address': {
              selfServe: {
                name: 'actv-myfido-change billing address',
                type: 'transaction'
              },
              page: {
                hierarchy: ['myaccount', 'view-profile']
              }
            },
            'change-billing-address-start': {
              page: {
                name: 'step1:billing address start'
              }
            },
            'change-billing-address-review': {
              page: {
                name: 'step2:billing address review',
                hierarchy: ['myaccount', 'view-profile']
              }
            },
            'change-billing-address-complete': {
              page: {
                name: 'step3:billing address success'
              }
            },
            'restart-modem': {
              selfServe: {
                name: 'actv-myfido-Restart Your Modem',
                type: 'transaction'
              }
            },
            'receive-puk': {
              selfServe: {
                name: 'actv-myfido-receive PUK code',
                type: 'transaction'
              }
            },
            'change-billing-type-update-email': {
              selfServe: {
                name: 'actv-myfido-contact information',
                type: 'transaction'
              }
            },
            'change-billing-type': {
              selfServe: {
                name: 'actv-myaccount-go paperless banner',
                type: 'transaction'
              }
            },
            'cancel-internet': {
              selfServe: {
                name: 'actv-myfido-Cancel Internet',
                type: 'transaction'
              }
            },
            'exchange-hardware': {
              selfServe: {
                name: 'pasv-myaccount-exchange hardware',
                type: 'inquiry'
              }
            },
            'payment-history': {
              selfServe: {
                name: 'pasv-myaccount-view payment history',
                type: 'inquiry'
              }
            },
            changeUserID: {
              selfServe: {
                name: 'actv-myfido-change username',
                type: 'transaction'
              }
            },
            changePassword: {
              selfServe: {
                name: 'actv-myfido-change password',
                type: 'transaction'
              }
            },
            'usage-text': {
              selfServe: {
                name: 'pasv-myaccount-view mobile text usage',
                type: 'inquiry'
              }
            },
            'usage-talk': {
              selfServe: {
                name: 'pasv-myaccount-view mobile talk usage',
                type: 'inquiry'
              }
            },
            'usage-data': {
              selfServe: {
                name: 'pasv-myaccount-view mobile data usage',
                type: 'inquiry'
              }
            },
            'usage-roaming': {
              selfServe: {
                name: 'pasv-myaccount-view my roaming usage',
                type: 'inquiry'
              }
            },
            saveBillPDF: {
              selfServe: {
                name: 'PDF',
                type: 'inquiry'
              }
            },
            saveBillExcel: {
              selfServe: {
                name: 'Excel',
                type: 'inquiry'
              }
            },
            saveBillCSV: {
              selfServe: {
                name: 'CSV',
                type: 'inquiry'
              }
            },
            saveBillPrint: {
              selfServe: {
                name: 'Print',
                type: 'inquiry'
              }
            },
            resetVoicemailPassword: {
              selfServe: {
                name: 'actv-myfido-update vm password',
                type: 'transaction'
              }
            },
            serviceAddressMoving: {
              selfServe: {
                name: 'pasv-myaccount-moving',
                type: 'inquiry'
              }
            },
            changeContactInfo: {
              selfServe: {
                name: 'actv-myfido-change contact information',
                type: 'transaction'
              }
            },
            textNotificationOn: {
              selfServe: {
                name: 'actv-myfido-bill notification SMS-ON',
                type: 'transaction'
              }
            },
            textNotificationOff: {
              selfServe: {
                name: 'actv-myfido-bill notification SMS-OFF',
                type: 'transaction'
              }
            },
            //--------------------------------------
            //        MY ACCOUNT STATE NAMES
            //--------------------------------------
            'easylogin/main': {
              //Currently handled by easy-login module
              //TODO: Handle page load tracking here instead
              events: {
                pageView: false
              }
            },
            linkAccounts: {
              page: {
                name: 'link-account',
                hierarchy: ['shop']
              },
              events: {
                pageView: true,
                selfServeStart: true
              },
              selfServe: {
                name: 'actv-myaccount-link account',
                type: 'transaction'
              }
            },
            'myAccount.internetUsage.monthly': {
              page: {
                name: 'monthly internet usage',
                hierarchy: ['myaccount', 'internet', 'usage', 'monthly']
              }
            },
            'myAccount.internetUsage.daily': {
              page: {
                name: 'daily internet usage',
                hierarchy: ['myaccount', 'internet', 'usage', 'daily']
              }
            },
            'myAccount.internetUsage.notification': {
              page: {
                name: 'internet usage notification',
                hierarchy: ['myaccount', 'internet', 'usage', 'notification']
              }
            },
            'myAccount.lostStolenReactivateDevice': {
              page: {
                name: 'lost stolen reactivate device',
                hierarchy: ['myaccount', 'wireless', 'lost-stolen-reactivate-device']
              }
            },
            'myAccount.lostStolenSuspendDevice': {
              page: {
                name: 'lost stolen suspend device',
                hierarchy: ['myaccount', 'wireless', 'lost-stolen-suspend-device']
              }
            },
            'myAccount.retrievePUK': {
              page: {
                name: 'retrieve puk',
                hierarchy: ['myaccount', 'retrievepuk']
              }
            },
            'myAccount.resetVoicemailPassword': {
              page: {
                name: 'reset voicemail password',
                hierarchy: ['myaccount', 'reset-voicemail-password']
              }
            },
            'myAccount.overview': {
              page: {
                name: 'overview',
                hierarchy: ['myaccount']
              }
            },
            'myAccount.viewProfile': {
              page: {
                name: 'view profile',
                hierarchy: ['myaccount', 'view-profile']
              }
            },
            myAccountViewProfile: {
              page: {
                name: 'view profile',
                hierarchy: ['myaccount', 'view-profile']
              }
            },
            'myAccount.wireless': {
              page: {
                name: 'wireless',
                hierarchy: ['myaccount', 'wireless']
              }
            },
            'myAccount.updateSimCard': {
              page: {
                name: 'update sim card',
                hierarchy: ['myaccount', 'wireless', 'update-sim-card']
              }
            },
            'myAccount.viewInvoice': {
              page: {
                name: 'view invoice history',
                hierarchy: ['myaccount', 'view-invoice-history']
              }
            },
            'myAccount.paymentMethod': {
              page: {
                name: 'payment method',
                hierarchy: ['myaccount', 'payment-method']
              }
            },
            'myAccount.paymentHistory': {
              page: {
                name: 'payment history',
                hierarchy: ['myaccount', 'payment-history']
              }
            },
            //--------------------------------------
            //        INTERNET STATE NAMES
            //--------------------------------------
            'link-account': {
              selfServe: {
                name: 'actv-myaccount-link account',
                type: 'transaction'
              }
            },
            internet: {
              page: {
                name: 'landing-page',
                hierarchy: ['internet', 'landing-page']
              }
            },
            cartSummary: {
              page: {
                name: 'cart-summary',
                hierarchy: ['internet', 'cart-summary']
              },
              buyflow: {
                name: 'internet new customer'
              },
              events: {
                cartView: true,
                buyFlowStart: true
              }
            },
            createUser: {
              page: {
                name: 'create-user',
                hierarchy: ['internet', 'checkout', 'create-user']
              },
              buyflow: {
                name: 'internet new customer'
              },
              events: {
                checkout: true
              }
            },
            creditCheck: {
              page: {
                name: 'credit-check',
                hierarchy: ['internet', 'checkout', 'credit-check']
              },
              buyflow: {
                name: 'internet new customer'
              }
            },
            shipToAddress: {
              page: {
                name: 'ship-to-address',
                hierarchy: ['internet', 'checkout', 'fulfillment', 'ship-to-address']
              },
              buyflow: {
                name: 'internet new customer'
              }
            },
            pickupAtStore: {
              page: {
                name: 'store-pickup',
                hierarchy: ['internet', 'checkout', 'fulfillment', 'store-pickup']
              },
              buyflow: {
                name: 'internet new customer'
              }
            },
            techInstall: {
              page: {
                name: 'tech-install',
                hierarchy: ['internet', 'checkout', 'fulfillment', 'tech-install']
              },
              buyflow: {
                name: 'internet new customer'
              }
            },
            takeItWithYou: {
              page: {
                name: 'take-it-with-you',
                hierarchy: ['internet', 'checkout', 'fulfillment', 'take-it-with-you']
              },
              buyflow: {
                name: 'internet new customer'
              }
            },
            paymentOptions: {
              page: {
                name: 'billing-options',
                hierarchy: ['internet', 'checkout', 'billing-options']
              },
              buyflow: {
                name: 'internet new customer'
              }
            },
            review: {
              page: {
                name: 'order-review',
                hierarchy: ['internet', 'checkout', 'order-review']
              },
              buyflow: {
                name: 'internet new customer'
              },
              events: {
                orderReview: true
              }
            },
            confirmation: {
              page: {
                name: 'confirm',
                hierarchy: ['internet', 'checkout', 'confirm']
              },
              buyflow: {
                name: 'internet new customer'
              },
              events: {
                purchase: true,
                buyFlowComplete: true
              }
            },
            'order-review': {
              //For change package scenario
              account: {
                internet: {
                  package: null //To be retrieved from SESSION STORAGE __adl.existingPackage
                }
              },
              buyflow: {
                name: 'internet change package'
              },
              events: {
                orderReview: true
              }
            },
            confirm: {
              //For change package scenario
              page: {
                name: 'confirm',
                hierarchy: ['myaccount', 'internet', 'change-package', 'checkout', 'confirm']
              },
              buyflow: {
                name: 'internet change package'
              },
              events: {
                purchase: true,
                buyFlowComplete: true
              }
            },
            'myAccount.internet.package': {
              page: {
                name: 'internet package',
                hierarchy: ['myaccount', 'internet', 'package']
              },
              events: {
                pageView: true
              }
            },
            'myAccount.internet.package.change.review': {
              page: {
                name: 'order-review',
                hierarchy: ['myaccount', 'internet', 'change-package', 'checkout', 'order-review']
              },
              events: {
                pageView: true
              }
            },
            //--------------------------------------------------------------------
            //             CUSTOM KEYS FOR INTERNET CHANGE PACKAGE
            //--------------------------------------------------------------------
            'internet-change-package': {
              account: {
                internet: {
                  package: null //To be retrieved from changeInternetPackage API
                }
              },
              page: {
                name: 'change-package',
                hierarchy: ['internet', 'landing-page', 'change-package']
              },
              events: {
                buyFlowStart: true
              },
              buyFlow: {
                name: 'internet change package'
              }
            },
            'my-account-internet-change-package': {
              account: {
                internet: {
                  package: null //To be retrieved from changeInternetPackage API
                }
              },
              page: {
                name: 'change-package',
                hierarchy: ['myaccount', 'internet', 'change-package']
              },
              buyflow: {
                name: 'internet change package'
              },
              events: {
                buyFlowStart: true
              }
            },
            'call-in': {
              account: {
                internet: {
                  package: null //To be retrieved from SESSION STORAGE __adl.existingPackage
                }
              },
              page: {
                name: 'call-in',
                hierarchy: ['myaccount', 'internet', 'change-package', 'call-in']
              },
              buyflow: {
                name: 'internet change package'
              }
            },
            //-------------------------------------------------------------
            //            EVENT TRACKING OR MODAL TRACKING POPUP KEYS
            //-------------------------------------------------------------
            'change-payment-method-pre-auth-confirm': {
              page: {
                name: 'modal-confirmation pre-authorized payment',
                hierarchy: ['myaccount', 'payment-method']
              }
            },
            'change-payment-method-invoice-confirm': {
              page: {
                name: 'modal-confirmation invoice',
                hierarchy: ['myaccount', 'payment-method'],
                url: 'modal popup'
              }
            },
            'change-payment-method-invoice-modal': {
              page: {
                name: 'modal-review invoice',
                hierarchy: ['myaccount', 'payment-method']
              }
            },
            'change-payment-method-pacc-confirm': {
              page: {
                name: 'modal-confirmation pre-authorized credit',
                hierarchy: ['myaccount', 'payment-method'],
                url: 'modal popup'
              }
            },
            'change-payment-method-pacc-modal': {
              page: {
                name: 'modal-review pre-authorized credit',
                hierarchy: ['myaccount', 'payment-method']
              }
            },
            'change-payment-method-pac-confirm': {
              page: {
                name: 'modal-confirmation pre-authorized chequing',
                hierarchy: ['myaccount', 'payment-method'],
                url: 'modal popup'
              }
            },
            'change-payment-method-pac-modal': {
              page: {
                name: 'modal-review pre-authorized chequing',
                hierarchy: ['myaccount', 'payment-method']
              }
            },
            'unlink-facebook-modal': {
              page: {
                name: 'modal-unlink facebook',
                hierarchy: ['myaccount', 'view-profile']
              }
            },
            'link-facebook-modal': {
              page: {
                name: 'modal-link facebook',
                hierarchy: ['myaccount', 'view-profile']
              }
            },
            saveBillCSVModal: {
              page: {
                name: 'save bill as csv',
                hierarchy: ['myaccount', 'view-invoice-history']
              }
            },
            saveBillPDFModal: {
              page: {
                name: 'save bill as pdf',
                hierarchy: ['myaccount', 'view-invoice-history']
              }
            },
            saveBillExcelModal: {
              page: {
                name: 'save bill as excel',
                hierarchy: ['myaccount', 'view-invoice-history']
              }
            },
            'user-ID-modal': {
              page: {
                name: 'modal-username',
                hierarchy: ['myaccount', 'view-profile'],
                url: 'modal popup'
              }
            },
            'user-password-modal': {
              page: {
                name: 'modal-password',
                hierarchy: ['myaccount', 'view-profile'],
                url: 'modal popup'
              }
            },
            'restart-modem-modal': {
              page: {
                name: 'modal-restart modem',
                hierarchy: ['myaccount', 'internet', 'package']
              }
            },
            'change-billing-type-confirmation-email-update-modal': {
              page: {
                name: 'modal-go paperless confirmation',
                hierarchy: ['myaccount', 'online-billing'],
                url: 'modal popup'
              }
            },
            'change-billing-type-confirmation-modal': {
              page: {
                name: 'modal-go paperless confirmation',
                hierarchy: ['myaccount', 'online-billing'],
                url: 'modal popup'
              }
            },
            'change-billing-type-update-email-modal': {
              page: {
                name: 'modal-update your email address',
                hierarchy: ['myaccount', 'online-billing'],
                url: 'modal popup'
              }
            },
            'change-billing-type-modal': {
              page: {
                name: 'modal-set up online billing',
                hierarchy: ['myaccount', 'online-billing']
              }
            },
            'moving-service-address': {
              page: {
                name: 'moving',
                hierarchy: ['myaccount', 'view-profile']
              }
            },
            'cancel-internet-modal': {
              page: {
                name: 'modal-cancel internet',
                hierarchy: ['myaccount', 'internet', 'package']
              }
            },
            'exchange-hardware-modal': {
              page: {
                name: 'modal-exchange hardware',
                hierarchy: ['myaccount', 'internet', 'package']
              }
            },
            'province-selection': {
              page: {
                name: 'province-selection',
                hierarchy: ['internet', 'province-selection']
              }
            },
            'service-open': {
              //modal popup with hash change
              page: {
                name: 'service-open',
                hierarchy: ['internet', 'landing-page', 'service-open']
              },
              buyflow: {
                name: 'internet new customer'
              },
              service: {
                availability: 'open',
                type: "fido internet"
              }
            },
            'service-wrong-province': {
              //modal popup with hash change
              page: {
                name: 'service-wrong-province',
                hierarchy: ['internet', 'landing-page', 'service-wrong-province']
              },
              buyflow: {
                name: 'internet new customer'
              }
            },
            'service-success': {
              //modal popup with hash change
              page: {
                //name: 'service-success',
                name: 'service-available',
                hierarchy: ['internet', 'landing-page', 'service-available'],
                url: 'modal popup'
              },
              buyflow: {
                name: 'internet new customer'
              },
              events: {
                serviceAvailCheck: true
              },
              service: {
                availability: 'available',
                id: 'hot',
                type: "fido internet"
              }
            },
            'service-cold': {
              //modal popup with hash change
              page: {
                name: 'service-available',
                hierarchy: ['internet', 'landing-page', 'service-available'],
                url: 'modal popup'
              },
              buyflow: {
                name: 'internet new customer'
              },
              events: {
                serviceAvailCheck: true
              },
              service: {
                availability: 'available',
                id: 'cold',
                type: "fido internet"
              }
            },
            'service-unwired': {
              //modal popup with hash change
              page: {
                name: 'service-available',
                hierarchy: ['internet', 'landing-page', 'service-available'],
                url: 'modal popup'
              },
              buyflow: {
                name: 'internet new customer'
              },
              events: {
                serviceAvailCheck: true
              },
              service: {
                availability: 'available',
                id: 'unwired',
                type: "fido internet"
              }
            },
            'service-multiple': {
              //modal popup with hash change
              page: {
                name: 'service-multiple',
                hierarchy: ['internet', 'landing-page', 'service-multiple'],
                url: 'modal popup'
              },
              buyflow: {
                name: 'internet new customer'
              }
            },
            'service-fail': {
              //modal popup with hash change
              page: {
                name: 'service-fail',
                hierarchy: ['internet', 'landing-page', 'service-fail'],
                url: 'modal popup'
              },
              buyflow: {
                name: 'internet new customer'
              },
              events: {
                serviceAvailCheck: true,
                search: true
              },
              service: {
                availability: 'not available'
              },
              search: {
                keyword: null, //To be retrieved from SESSION STORAGE __adl.postal
                type: 'serviceability search'
              }
            },
            'service-unknown': {
              //modal popup with hash change
              page: {
                name: 'service-unknown',
                hierarchy: ['internet', 'landing-page', 'service-unknown'],
                url: 'modal popup'
              },
              buyflow: {
                name: 'internet new customer'
              },
              events: {
                serviceAvailCheck: true,
                search: true
              },
              service: {
                availability: 'unknown'
              },
              search: {
                keyword: null, //To be retrieved from SESSION STORAGE __adl.postal
                type: 'serviceability search'
              }
            },
            'internet-update': {
              //triggered by event directive
              page: {
                name: 'update',
                hierarchy: ['internet', 'landing-page', 'update']
              },
              buyflow: {
                name: 'internet change package'
              }
            },
            'myAccount-internet-package-update': {
              //triggered by event directive
              page: {
                name: 'update',
                hierarchy: ['myaccount', 'internet', 'change-package', 'update']
              },
              buyflow: {
                name: 'internet change package'
              }
            },
            'confirm-update-package': {
              page: {
                name: 'confirm-update-package',
                hierarchy: ['internet', 'confirm-update-package']
              },
              buyflow: {
                name: 'internet new customer'
              }
            },
            'confirmation-store-locator': {
              page: {
                name: 'confirmation-store-locator',
                hierarchy: ['internet', 'checkout', 'confirm', 'confirmation-store-locator']
              },
              buyflow: {
                name: 'internet new customer'
              }
            },
            'add-a-line-modal': {
              page: {
                name: 'modal-add a line or contact',
                hierarchy: ['mobile', 'ecom', 'aal', 'add-a-line'],
                url: 'modal popup'
              }
            },
            //-------------------------------------------------------------
            //               FORM FIELD ERROR & ERROR KEYS
            //-------------------------------------------------------------
            f0: 'email',
            f1: 'confirm email',
            f2: 'first name',
            f3: 'last name',
            f4: 'phone',
            f5: 'another billing address',
            f6: 'date of birth',
            f7: 'credit card number',
            f8: 'credit card expiry month',
            f9: 'credit card expiry year',
            f10: "driver's license province",
            f11: "driver's license expiry date",
            f12: "driver's license expiry month",
            f13: "driver's license expiry day",
            f14: "driver's license expiry year",
            f15: "driver's license number",
            f16: 'social insurance number',
            f17: 'passport number',
            f18: 'passport expiry date',
            f19: 'passport expiry month',
            f20: 'passport expiry day',
            f21: 'passport expiry year',
            f22: 'birth certificate number',
            f23: 'citizenship number',
            f24: 'ID Option 1',
            f25: 'ID Option 2',
            f26: 'credit check',
            f27: 'use another address',
            f28: 'another billing address',
            f29: 'customer understands above',
            f30: 'additional agreement details',
            f31: 'service multiple addresses',
            f32: 'study permit number',
            f33: 'study permit expiry date',
            f34: 'study permit expiry month',
            f35: 'study permit expiry day',
            f36: 'study permit expiry year',
            f37: 'modem serial number',
            f38: 'credit card security code',
            f39: 'pre-authorized chequing transit code',
            f40: 'pre-authorized chequing bank code',
            f41: 'pre-authorized chequing account number',
            f42: 'pre-authorized chequing terms & conditions',
            f43: 'credit card expiry date',
            f44: 'address lookup',
            f45: 'tech install select timeslot',
            f46: 'billing address',
            f47: 'new password',
            f48: 'confirm password',
            f49: 'sim number',
            f50: 'account number',
            f51: 'postal code',
            f52: 'phone number',
            f53: 'company name',
            f54: 'credit card expiry date',
            error: {
              'upgrade-my-device-error': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'wireless', 'upgrade-my-device']
                }
              },
              'add-a-line-error': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'add-a-line']
                }
              },
              'add-a-line-modal': {
                page: {
                  name: 'modal',
                  hierarchy: ['myaccount', 'add-a-line']
                }
              },
              'ppc-pending-error': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'wireless', 'change-price-plan']
                }
              },
              'myAccount-paymentMethod': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'payment-method']
                }
              },
              'update-sim-card-error': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'wireless', 'update-sim-card']
                }
              },
              onboarding: {
                page: {
                  name: 'overview',
                  hierarchy: ['myaccount']
                }
              },
              'reset-voicemail-pass-error': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'reset-voicemail-password']
                }
              },
              'billing-type-change-modal': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'online-billing']
                }
              },
              'billing-type-update-email-modal': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'online-billing']
                }
              },
              'lost-suspend-stolen-error': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'wireless', 'lost-stolen-suspend-device']
                }
              },
              'change-billing-address-error': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'view-profile']
                }
              },
              changeContactInfo: {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'view-profile']
                }
              },
              'internet-new-customer': {
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'landing-page']
                }
              },
              'service-auid': {
                page: {
                  name: 'service-auid',
                  hierarchy: ['internet', 'landing-page', 'service-auid'],
                  url: 'modal popup'
                },
                buyflow: {
                  name: 'internet new customer'
                },
                events: {
                  serviceAvailCheck: true,
                  search: true
                },
                service: {
                  availability: 'unknown'
                },
                search: {
                  keyword: null, //To be retrieved from SESSION STORAGE __adl.postal,
                  type: 'serviceability search'
                }
              },
              'service-error': {
                page: {
                  //name: 'error',
                  name: 'service-unavailable',
                  hierarchy: ['internet', 'landing-page'],
                  url: 'modal popup'
                },
                buyflow: {
                  name: 'internet new customer'
                },
                events: {
                  serviceAvailCheck: true,
                  search: true
                },
                service: {
                  //availability: 'unknown',
                  availability: 'unavailable',
                  type: 'fido internet'
                },
                search: {
                  keyword: null, //To be retrieved from SESSION STORAGE __adl.postal
                  type: 'serviceability search'
                }
              },
              cartSummary: {
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'cart-summary']
                }
              },
              'internet-change-package': {
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'landing-page', 'change-package']
                }
              },
              'my-account-internet-change-package': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'internet', 'change-package']
                }
              },
              createUser: {
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'checkout', 'create-user']
                },
                buyflow: {
                  name: 'internet new customer'
                }
              },
              creditCheck: {
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'checkout', 'credit-check']
                },
                buyflow: {
                  name: 'internet new customer'
                }
              },
              shipToAddress: {
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'checkout', 'fulfillment', 'ship-to-address']
                },
                buyflow: {
                  name: 'internet new customer'
                }
              },
              pickupAtStore: {
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'checkout', 'fulfillment', 'store-pickup']
                },
                buyflow: {
                  name: 'internet new customer'
                }
              },
              techInstall: {
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'checkout', 'fulfillment', 'tech-install']
                },
                buyflow: {
                  name: 'internet new customer'
                }
              },
              takeItWithYou: {
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'checkout', 'fulfillment', 'takeItWithYou']
                },
                buyflow: {
                  name: 'internet new customer'
                }
              },
              paymentOptions: {
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'checkout', 'billing-options']
                },
                buyflow: {
                  name: 'internet new customer'
                }
              },
              review: {
                //payload to be populated by callback function
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'checkout', 'order-review']
                },
                buyflow: {
                  name: 'internet new customer'
                }
              },
              confirm: {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'internet', 'change-package', 'checkout', 'confirm']
                },
                buyflow: {
                  name: 'internet change package'
                }
              },
              'order-review': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'internet', 'change-package', 'checkout', 'order-review']
                },
                buyflow: {
                  name: 'internet change package'
                }
              },
              'myAccount-internet-package-change-review': {
                page: {
                  name: 'error',
                  hierarchy: ['myaccount', 'internet', 'change-package', 'checkout', 'order-review']
                },
                buyflow: {
                  name: 'internet change package'
                }
              },
              'select-time-slot': {
                //tech install timeslot form field
                page: {
                  name: 'error',
                  hierarchy: ['internet', 'checkout', 'fulfillment', 'tech-install', 'select-time-slot']
                },
                buyflow: {
                  name: 'internet new customer'
                }
              }
            } //error
          } //mappingKey
        }, //advance
        //---------------------------------------------------------------
        //                   MODAL TRACKING
        //---------------------------------------------------------------
        modal: {
          'modules/checkout/views/edit-package.html': {
            response: function(cfg, stateName) {
              var data = {
                payload: getPayload(stateName)
              };
              data.payload.page.name = 'modal-change package';
              delete data.payload.events.orderReview;
              return data;
            }
          },
          'modules/user/views/confirm-fbunlink.html': {
            response: function(cfg, stateName) {
              var data = {
                payload: getPayload(stateName + ',unlink-facebook-modal,unlink-facebook,event.selfServeStart')
              };
              return data;
            }
          },
          emailNotVerified: {
            response: function(cfg, stateName) {
              var data = {
                payload: getPayload(
                  stateName + ',accountRegistration.main,prepaid-registration,event.selfServeComplete'
                )
              };
              data.payload.page.name = 'modal-prepaid registration complete';
              return data;
            }
          },
          traditionalRegistration: {
            response: function(cfg, stateName) {
              var data = {
                payload: getPayload(stateName + ',accountRegistration.main,prepaid-registration,event.selfServeStart')
              };
              data.payload.page.name = 'modal-prepaid registration start';
              return data;
            }
          },
          'modules/my-account/view-invoice/printInvoice.html': {
            response: function(cfg, stateName) {
              var data = { payload: getPayload(stateName + ',saveBillPrint,event.selfServeComplete') };
              if (_.has(data, 'payload.page.name')) {
                data.payload.page.name = 'print bill pdf';
              }
              return data;
            }
          },
          'modules/my-account/overview/learn-more-online-billing.html': {
            response: function(cfg, stateName) {
              return {
                payload: getPayload(stateName + ',change-billing-type,change-billing-type-modal,event.selfServeStart')
              };
            }
          },
          'modules/my-account/internet/exchange-hardware-modal.html': {
            response: function(cfg, stateName) {
              return {
                payload: getPayload(stateName + ',exchange-hardware-modal,exchange-hardware,event.selfServeComplete')
              };
            }
          },
          changeUserID: {
            response: function(cfg, stateName) {
              return { payload: getPayload(stateName + ',user-ID-modal,changeUserID,event.selfServeStart') };
            }
          },
          changePassword: {
            response: function(cfg, stateName) {
              return {
                payload: getPayload(stateName + ',user-password-modal,changePassword,event.selfServeStart')
              };
            }
          },
          'views/templates/modal/province-selection-modal.html': {
            response: function(cfg, stateName) {
              return { payload: getPayload('province-selection') };
            }
          },
          'views/templates/modal/check-availability.html': {
            response: function(cfg, stateName) {
              return { payload: getPayload('service-open') };
            }
          },
          'modules/checkout/views/add-to-cart.html': {
            response: function(cfg, stateName) {
              return { payload: getPayload('confirm-update-package') };
            }
          },
          'views/templates/modal/remove-from-cart.html': {
            response: function(cfg, stateName) {
              var data = { payload: getPayload(stateName) };
              data.payload.page.name = 'confirm-remove-package';
              data.payload.page.hierarchy.push(data.payload.page.name);
              delete data.payload.events;
              return data;
            }
          },
          'modules/checkout/views/store-locator-modal.html': {
            response: function(cfg, stateName) {
              return { payload: getPayload('confirmation-store-locator') };
            }
          },
          'uteModal/modal.html': {
            response: function(cfg, stateName) {
              var data = {};
              if (stateName === 'techInstall') {
                data = {
                  payload: getPayload('error.select-time-slot'),
                  isError: true,
                  errorMessage: cfg.message,
                  errorField: getPayload('f45'),
                  errorCategory: [ute.datalayer.common.service.ErrorCategory['BUYFLOW']]
                };
              }
              return data;
            }
          }
        },
        //---------------------------------------------------------------
        //                       API TRACKING
        //---------------------------------------------------------------
        api: {
          'api/selfserve/v1/wireless/lostorstolen/remove': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.error) {
                payload = getPayload('reactivate-device,event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              return data;
            }
          },
          'api/selfserve/v1/wireless/updatePaymentMethod': {
            request: function(request, api, state, $injector) {
              creditCardInfoRequest = request.data;
            },
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.error) {
                if (creditCardInfoRequest.mopType === 'pac') {
                  payload = getPayload(
                    'change-payment-method-pac-confirm,change-payment-method,event.selfServeComplete'
                  );
                  payload.ecommerce.paymentMethods = ['bank account'];
                  payload.events.autopay = true;
                  creditCardInfoRequest = null;
                } else if (creditCardInfoRequest.mopType === 'pacc') {
                  payload = getPayload(
                    'change-payment-method-pacc-confirm,change-payment-method,event.selfServeComplete'
                  );
                  payload.ecommerce.paymentMethods = [creditCardInfoRequest['CreditCardInfo.ccType']];
                  payload.events.autopay = true;
                  creditCardInfoRequest = null;
                } else if (creditCardInfoRequest.mopType === 'invoice') {
                  payload = getPayload(
                    'change-payment-method-invoice-confirm,change-payment-method-invoice,event.selfServeComplete'
                  );
                  payload.ecommerce.paymentMethods = ['manual payment'];
                  creditCardInfoRequest = null;
                }
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, isModalPopup: true };
                }
              }
              return data;
            }
          },
          'api/selfserve/v2/updatePaymentMethod': {
            request: function(request, api, state, $injector) {
              creditCardInfoRequest = request.data;
            },
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.error) {
                if (creditCardInfoRequest.mopType === 'pac') {
                  payload = getPayload(
                    'change-payment-method-pac-confirm,change-payment-method,event.selfServeComplete'
                  );
                  payload.ecommerce.paymentMethods = ['bank account'];
                  payload.events.autopay = true;
                  creditCardInfoRequest = null;
                } else if (creditCardInfoRequest.mopType === 'pacc') {
                  payload = getPayload(
                    'change-payment-method-pacc-confirm,change-payment-method,event.selfServeComplete'
                  );
                  payload.ecommerce.paymentMethods = [creditCardInfoRequest['CreditCardInfo.ccType']];
                  payload.events.autopay = true;
                  creditCardInfoRequest = null;
                } else if (creditCardInfoRequest.mopType === 'invoice') {
                  payload = getPayload(
                    'change-payment-method-invoice-confirm,change-payment-method-invoice,event.selfServeComplete'
                  );
                  payload.ecommerce.paymentMethods = ['manual payment'];
                  creditCardInfoRequest = null;
                }
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, isModalPopup: true };
                }
              }
              return data;
            }
          },
          'api/selfserve/v1/wireless/updateEquipment': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.error) {
                payload = getPayload('update-sim-card,event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              return data;
            }
          },
          'api/selfserve/v1/wireless/lostorstolen/add': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.error) {
                payload = getPayload('lost-stolen-device,event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              return data;
            }
          },
          'api/selfserve/v1/updateProfile': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.error) {
                payload = getPayload('changeUserID,event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              return data;
            }
          },
          'api/selfserve/v2/updateCustomerBillingProfile': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if (response.status === 200 || response.status === 201) {
                payload = getPayload('change-billing-address,event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              return data;
            }
          },
          'api/selfserve/v2/resetPin': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if (response.status === 200 || response.status === 201) {
                payload = getPayload('restart-modem,event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              return data;
            }
          },
          'api/selfserve/v1/puk/pukcode': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.error) {
                payload = getPayload('receive-puk,event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              if (r.error) {
                payload = getPayload('error.' + state);
                return getResponseErrorPayload(payload, r.error, '', 'self_serve', 'http', api, false, $injector);
              }
              return data;
            }
          },
          'api/selfserve/v1/update/customer/billing/media': {
            request: function(request, api, state, $injector) {
              contactOnlineBillingEmail = request.data.emailId;
            },
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r[0].error) {
                payload = getPayload(
                  'change-billing-type-update-email,change-billing-type-confirmation-email-update-modal,event.selfServeComplete'
                );
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, isModalPopup: true };
                }
              }
              if (contactOnlineBillingEmail === getSessionStorage('__adl', 'userID')) {
                contactOnlineBillingEmail = null;
              } else {
                contactOnlineBillingEmail = null;
                return data;
              }
            }
          },
          'api/selfserve/v1/wireless/voicemail/password/reset': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.error) {
                payload = getPayload('resetVoicemailPassword,event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              if (r.error) {
                payload = getPayload('error.' + state);
                return getResponseErrorPayload(payload, r.error, '', 'self_serve', 'http', api, false, $injector);
              }
              return data;
            }
          },
          'api/selfserve/v2/updateContactInformation': {
            response: function(response, api, state, $injector) {
              if (state === 'myAccount.viewProfile') {
                var r = response.data,
                  data = {},
                  payload = {};
                if ((response.status === 200 || response.status === 201) && !r.error) {
                  payload = getPayload('changeContactInfo,event.selfServeComplete');
                  if (!_.isEmpty(payload)) {
                    data = { payload: payload, pageView: false };
                  }
                }
                if (r.error) {
                  payload = getPayload('error.' + state);
                  return getResponseErrorPayload(payload, r.error, '', 'self_serve', 'http', api, false, $injector);
                }
                return data;
              }
            },
            responseError: function(rejection, api, state, $injector) {
              if (state === 'myAccount.viewProfile') {
                try {
                  var code = rejection.status;
                  if (code !== 0 && code !== -1) {
                    var message = JSON.stringify(rejection.data);
                    var category = 'self serve';
                    return getDefaultErrorPayload({}, code, message, category, 'http', api, false);
                  }
                } catch (e) {
                  console.warn('ADL error in updateContactInformation.responseError method: ', e);
                }
              }
            }
          },
          'api/selfserve/v2/paymentHistory': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.getPaymentHistory.error) {
                payload = getPayload('payment-history,event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              return data;
            }
          },
          'api/selfserve/v1/wireless/paymentHistory': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.getPaymentHistory.error) {
                payload = getPayload('payment-history,event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              return data;
            }
          },
          '/api/selfserve/v1/logout': {
            request: function(request, api, state, $injector) {
              //Remove session storage on logout
              sessionStorage.removeItem('__adl');
            }
          },

          '/api/selfserve/v2/accountOverview': {
            response: function(response, api, state, $injector) {
              var r = response.data;
              var subscriberService = _.get(r, 'getAccountInfo.subscriberService', '');
              var default_ctn_set = false;

              //Getting User ID
              updateSessionStorage('__adl', { userID: _.get(r, 'getAccountInfo.primaryEmailID', '') });

              //Checking for existing package and save the info in sessionStorage
              subscriberService.forEach(function(services) {
                var service = _.get(services, 'service', []);
                service.forEach(function(s) {
                  if (_.get(s, 'serviceName', '') === 'HSI') {
                    updateSessionStorage('__adl', { HSI: true });
                  } else if (!default_ctn_set && _.get(s, 'serviceName', '') === 'CTN') {
                    default_ctn_set = true;
                    updateSessionStorage('__adl', { CTN: _.get(s, 'subscriberNo', '') });
                  }
                });
              });
            }
          },
          '/api/selfserve/v2/internetOffers': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};

              //Error Scenarios (internet / cartSummary)
              if (r.error) {
                payload = getPayload('error.' + state);
                return getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, true, $injector);
              }
              return data;
            }
          },
          '/api/selfserve/v1/addressServices': {
            request: function(request, api, state, $injector) {
              var r = request.data;
              var postal = _.get(parseAddress(r), 'postalCode', '');
              updateSessionStorage('__adl', { postal: postal });
            },

            response: function(response, api, state, $injector) {
              var $rootScope = $injector.get('$rootScope');
              var r = response.data,
                errorMessage,
                key,
                data = {},
                payload = {},
                success = false;

              //Received error or invalidAUID
              if (r.error) {
                if (r.error === '10068') {
                  errorMessage = 'global.label.havingTroubleFindingInternet';
                  key = 'service-auid';
                } else {
                  errorMessage = $rootScope.ruiMethods.user.is.agent()
                    ? 'retail.message.notServiceable'
                    : 'global.message.notServiceable';
                  key = 'service-error';
                }
                
                payload = getPayload('error.' + key);
              }

              //Multiple addresses found
              else if (r.multipleUnits === true) {
                payload = getPayload('service-multiple');
                success = true;
              }

              //Service found
              else if (r.serviceAddressInd === true && r.serviceAddressID !== '') {
                if (r.cableCondition == 'Unwired') { //CH-4586
                  payload = getPayload('service-unwired');
                  success = true;
                } else if (r.cableCondition == 'Cold') {
                  payload = getPayload('service-cold');
                  success = true;
                } else {
                  payload = getPayload('service-success');
                  success = true;
                }
              }

              //Fraud
              else if (r.callCare === true) {
                payload = getPayload('service-fail');
                payload.page.name = 'service-fraud';
                payload.page.hierarchy.splice(2, 1, payload.page.name);
              }

              //Not serviceable
              else if (r.serviceAddressInd === false || r.serviceAddressID === '') {
                payload = getPayload('service-fail');
                payload.page.name = 'service-not-serviceable';
                payload.page.hierarchy.splice(2, 1, payload.page.name);
              }

              //No service found
              else if (r.serviceAddressInd === '') {
                payload = getPayload('service-fail');
                payload.page.name = 'service-no-service-found';
                payload.page.hierarchy.splice(2, 1, payload.page.name);
              }

              //Other scenarios
              else {
                payload = getPayload('service-unknown');
              }

              //Getting postal code for failed and unknown scenarios
              if (!success && _.has(payload, 'search.keyword')) {
                payload.search.keyword = _.get(JSON.parse(sessionStorage.getItem('__adl')), 'postal');
              }

              //Returing payload or error payload
              if (!_.isEmpty(payload)) {
                data = r.error
                  ? getResponseErrorPayload(payload, r.error, errorMessage, 'buyflow', 'location', api, true, $injector)
                  : { payload: payload };
              }
              return data;
            }
          },
          '/api/selfserve/v3/changeInternetPackage': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              var key = state === 'internet' ? 'internet-change-package' : 'my-account-internet-change-package';

              //Change internet package
              if (!r.error) {
                data = { payload: getPayload(key) };
                data.payload.account.internet.package = getExistingPackageSku(
                  _.get(r, 'changeInternetPackage.en.tier')
                );
              }

              //Error scenarios
              else if (r.error) {
                payload = getPayload('error.' + key);
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, true, $injector);
              }
              return data;
            }
          },
          '/api/selfserve/v1/reviewOrder': {
            response: function(response, api, state, $injector) {
              var $rootScope = $injector.get('$rootScope');
              var r = response.data,
                data = {},
                payload = {};

              //Call-in scenario
              if (r.error === '237001') {
                payload = getPayload('call-in');
                payload.account.internet.package = _.get(
                  JSON.parse(sessionStorage.getItem('__adl')),
                  'existingPackage'
                );
                data = { payload: payload };
              }

              //Error scenarios
              else if (r.error) {
                payload = getPayload('error.myAccount-internet-package-change-review');
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, true, $injector);
              }

              //Change internet package order-review
              else if (!r.error) {
                payload = getPayload('order-review,myAccount.internet.package.change.review');
                constructBuyflowPayload(payload, _.get($rootScope, 'atg.userId.value', ''));
                payload.account.internet.package = _.get(
                  JSON.parse(sessionStorage.getItem('__adl')),
                  'existingPackage'
                );
                constructProductsPayload(payload, getProductObject(r));
                data = { payload: payload };
              }
              return data;
            }
          },
          '/api/selfserve/v1/confirmOrder': {
            response: function(response, api, state, $injector) {
              var $rootScope = $injector.get('$rootScope');
              var r = response.data,
                errorCode,
                data = {},
                payload = {};
              var error = _.get(r, 'confirmChangeInternetPkg.error', false);

              //Error scenarios
              if (error || r.error) {
                errorCode = _.get(r, 'error', error);
                payload = getPayload('error.confirm');
                data = getResponseErrorPayload(payload, errorCode, '', 'buyflow', 'http', api, true, $injector);
              }

              //Change internet package confirmation
              else {
                payload = getPayload('confirm');
                constructBuyflowPayload(payload, _.get($rootScope, 'atg.userId.value', ''));
                constructEcommercePayload(payload, _.get(r, 'confirmChangeInternetPkg', ''));
                constructProductsPayload(payload, getProductObject(r));
                sessionStorage.removeItem('__adl');
                data = { payload: payload };
              }
              return data;
            }
          },
          '/api/selfserve/v2/searchCustomerDetails': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload;

              //ECID-Specific R1117
              if (r.error) {
                payload = getPayload('error.creditCheck');
                data = getResponseErrorPayload(
                  payload,
                  r.reasonCode,
                  r.reasonMessage,
                  'buyflow',
                  'credit',
                  r.backend,
                  true,
                  $injector
                );
              }
              return data;
            }
          },
          '/api/selfserve/v1/verifyExistingJanrainCustomer': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                errorMessage,
                payload;
              var $rootScope = $injector.get('$rootScope');

              //Email already exists
              if (r.isExisted === true) {
                errorMessage = $rootScope.ruiMethods.user.is.agent()
                  ? 'retail.message.customerExists'
                  : 'global.error.inline.email.existing';
                payload = getPayload('error.createUser');
                data = getResponseErrorPayload(payload, '', errorMessage, 'buyflow', 'user', api, true, $injector);
              }

              //Error scenarios
              else if (r.error) {
                payload = getPayload('error.createUser');
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, true, $injector);
              }

              return data;
            }
          },
          '/api/selfserve/v1/createContact': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload;

              //Error scenarios
              if (r.error) {
                payload = getPayload('error.creditCheck');
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, $injector);
              }
              return data;
            }
          },
          '/api/selfserve/v1/creditCheck': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload;

              //Error scenarios

              if (r.nextOperation && r.nextOperation.toUpperCase() === 'NEGATIVE') {
                data = getResponseErrorPayload(
                  payload,
                  r.riskClass,
                  'global.error.postBack.riskClass.' + r.riskClass,
                  'buyflow',
                  'credit',
                  api,
                  true,
                  $injector
                );
              } else if (r.error) {
                payload = getPayload('error.creditCheck');
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'credit', api, true, $injector);
              }
              return data;
            }
          },
          '/api/selfserve/fullfillmentOptions': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload;

              //Error scenarios
              if (r.error) {
                payload = getPayload('error.creditCheck');
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, true, $injector);
              }
              return data;
            }
          },
          '/api/selfserve/submitfullfillmentOptions': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload;
              var errorMapping = {
                '60000': 'global.error.postBack.serial.invalid',
                '60001': 'global.error.postBack.serial.inUse',
                '30001': 'global.error.postBack.serial.ineligibleForExchange',
                '30002': 'global.error.postBack.serial.nonMatching'
              };

              //Error scenarios
              if (r.error) {
                payload = getPayload('error.creditCheck');
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, true, $injector);
              }
              return data;
            }
          },
          '/api/selfserve/v1/createFinancialAccount': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload;

              //Error scenarios
              if (r.error) {
                payload = getPayload('error.paymentOptions');
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, true, $injector);
              }
              return data;
            }
          },
          '/api/selfserve/v1/submitOrder': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload;

              //Error scenarios
              if (r.error) {
                payload = getPayload('error.review');
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, true, $injector);
              }

              return data;
            }
          },
          '/api/selfserve/v1/hybrid/submit': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};
              if ((response.status === 200 || response.status === 201) && !r.error) {
                payload = getPayload('confirmation');
                delete payload.page;
                if (!_.isEmpty(payload)) {
                  data = { payload: payload, pageView: false };
                }
              }
              //Error scenarios
              if (r.error) {
                payload = getPayload('error.review');
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, true, $injector);
              }
              return data;
            }
          },
          '/api/selfserve/shoppingCart': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload;

              //Error scenarios
              if (r.error) {
                payload = getPayload('error.review');
                data = getResponseErrorPayload(payload, r.error, '', 'buyflow', 'http', api, true, $injector);
              }
              return data;
            }
          },
          '/api/selfserve/loginCompleteRegistration': {
            responseError: function(response, api, state, $injector) {
              return getResponseErrorPayload(
                {},
                _.get(response, 'data.errorCode', response.status),
                'Error occurred while submitting form.',
                'SELF_SERVE',
                'http',
                api,
                false,
                $injector
              );
            }
          },
          '/api/selfserve/v1/validateURL': {
            responseError: function(response, api, state, $injector) {
              return getResponseErrorPayload(
                {},
                _.get(response, 'data.errorCode', response.status),
                'global.error.inline.link.cannotValidate',
                'SELF_SERVE',
                'http',
                api,
                false,
                $injector
              );
            }
          },
          '/api/selfserve/v1/expiredLink': {
            responseError: function(response, api, state, $injector) {
              return getResponseErrorPayload(
                {},
                _.get(response, 'data.errorCode', response.status),
                'global.error.inline.link.problemSendingRegistrationLinkPt1',
                'SELF_SERVE',
                'http',
                api,
                false,
                $injector
              );
            }
          },
          '/api/selfserve/linkAccountOwner': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};

              if (!r.error) {
                payload = getPayload('link-account, event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload };
                }
                return data;
              } else {
                return linkAccountHelper(r, api, $injector);
              }
            },
            responseError: linkAccountErrorHelper
          },
          '/api/selfserve/linkAccountSubscriber': {
            response: function(response, api, state, $injector) {
              var r = response.data;
              if (r.error) {
                return linkAccountHelper(r, api, $injector);
              }
            },
            responseError: linkAccountErrorHelper
          },
          '/api/selfserve/validateLinkAccountSubscriber': {
            response: function(response, api, state, $injector) {
              var r = response.data,
                data = {},
                payload = {};

              if (!r.error) {
                payload = getPayload('link-account, event.selfServeComplete');
                if (!_.isEmpty(payload)) {
                  data = { payload: payload };
                }
                return data;
              } else {
                return linkAccountHelper(r, api, $injector);
              }
            },
            responseError: linkAccountErrorHelper
          },
          '/OnlineProfile/onBoardingMessageStatus': {
            // Suppress global error tracking for OnlineProfile/onBoardingMessageStatus API
            responseError: function() {
              return null;
            }
          },
          default: {
            responseError: function(rejection, api, state, $injector) {
              try {
                var code = rejection.status;
                if (code !== 0 && code !== -1) {
                  var message = JSON.stringify(rejection.data);
                  var category = isInternetFlow(state) ? 'buyflow' : 'self_serve';
                  return getDefaultErrorPayload({}, code, message, category, 'http', api, false);
                }
              } catch (e) {
                console.warn('ADL error in default.responseError method: ', e);
              }
            }
          }
        } //api
      };
      dataLayerServiceProvider.configure(config);
    }
  ]);

  function linkAccountHelper(r, api, $injector) {
    var data;
    var errorMessages = {
      '1906': '',
      '50000': 'global.error.postBack.50000',
      '55055': '',
      '70011': '',
      '70012': 'global.error.postBack.50000',
      '70013': 'global.error.inline.account.linkFailed',
      '70014': 'global.error.inline.info.nonExistent',
      '70015': 'global.error.postBack.account.70015',
      '70016': 'global.error.postBack.account.70016'
    };

    switch (r.error) {
      case '50000':
        data = getResponseErrorPayload({}, r.error, errorMessages['50000'], 'SELF_SERVE', 'http', api, true, $injector);
        break;
      case '70012':
        data = getResponseErrorPayload({}, r.error, errorMessages['70012'], 'SELF_SERVE', 'http', api, true, $injector);
        break;
      case '70013':
        data = getResponseErrorPayload({}, r.error, errorMessages['70013'], 'SELF_SERVE', 'user', api, true, $injector);
        break;
      case '70014':
        data = getResponseErrorPayload({}, r.error, errorMessages['70014'], 'SELF_SERVE', 'user', api, true, $injector);
        break;
      case '70015':
        data = getResponseErrorPayload({}, r.error, errorMessages['70015'], 'SELF_SERVE', 'user', api, true, $injector);
        break;
      case '70016':
        data = getResponseErrorPayload({}, r.error, errorMessages['70016'], 'SELF_SERVE', 'http', api, true, $injector);
        break;
      default:
        data = getResponseErrorPayload({}, r.error, errorMessages['50000'], 'SELF_SERVE', 'http', api, true, $injector);
    }
    return data;
  }

  function linkAccountErrorHelper(response, api, state, $injector) {
    return getResponseErrorPayload(
      {},
      _.get(response, 'data.error', response.status),
      'global.error.postBack.50000',
      'SELF_SERVE',
      'http',
      api,
      false,
      $injector
    );
  }

  function getTranslatedMessage(code, message, $injector) {
    var $translate = $injector.get('$translate');
    var errorCodeMap = $injector.get('errorCodeMap');
    message = message || _.get(errorCodeMap, code + '.desc', 'global.error.postBack.systemError');
    return $translate(message)
      .then(function(response) {
        return response
          .replace(/<(?:.|\n)*?>/gm, ' ')
          .replace(/  +/g, ' ')
          .trim();
      })
      .catch(function(err) {
        return message;
      });
  }

  function getResponseErrorPayload(
    payload,
    errorCode,
    errorMessage,
    errorCategory,
    errorType,
    errorAPI,
    isModalPopup,
    $injector
  ) {
    return getTranslatedMessage(errorCode, errorMessage, $injector).then(function(tMessage) {
      return getDefaultErrorPayload(payload, errorCode, tMessage, errorCategory, errorType, errorAPI, isModalPopup);
    });
  }

  function getDefaultErrorPayload(payload, errorCode, errorMessage, errorCategory, errorType, errorAPI, isModalPopup) {
    return {
      payload: payload || {},
      errorCode: errorCode,
      errorMessage: errorMessage,
      errorCategory: [ute.datalayer.common.service.ErrorCategory[errorCategory.toUpperCase()]],
      errorType: [ute.datalayer.common.service.ErrorType[errorType.toUpperCase()]],
      errorAPI: errorAPI,
      isModalPopup: isModalPopup,
      isError: true
    };
  }

  function getErrorMessage(obj, paths, recursive) {
    if (paths.length === 0 && paths.constructor !== Array) {
      return '';
    } else if (paths.length === 1) {
      var msg = _.get(obj, paths[0], !recursive && typeof obj === 'object' ? JSON.stringify(obj) : '');
      return typeof msg === 'object' ? JSON.stringify(msg) : msg;
    } else {
      return (
        (getErrorMessage(obj, paths.splice(0, 1), true) + ' ' + getErrorMessage(obj, paths, true)).trim() ||
        (typeof obj === 'object' ? JSON.stringify(obj) : obj)
      );
    }
  }

  function updateSessionStorage(key, obj) {
    var existingData = JSON.parse(sessionStorage.getItem(key)) || {};
    var newData = _.merge(existingData, obj);
    sessionStorage.setItem(key, JSON.stringify(newData));
  }

  function constructBuyflowPayload(payload, serial) {
    if (serial) {
      var obj = {
        buyflow: {
          serial: serial
        }
      };
      _.merge(payload, obj);
    }
  }

  function getProductObject(response) {
    var product = {};
    var pkg = _.get(response, 'confirmChangeInternetPkg', _.get(response, 'reviewChangeInternetPkg'));
    var added = _.get(pkg, 'packageAdded.products.offers', '');
    var removed = _.get(pkg, 'packageRemoved.products.offers', '');

    if (!_.isEmpty(added)) {
      product.name = added.name;
      product.ID = added.offerId;
      product.category = 'internet';
      product.subCategory = 'package';
      if (_.get(response, 'confirmChangeInternetPkg')) {
        product.MSF = Number(_.get(added, 'offerPrice.price', 0))
          .toFixed(2)
          .toString();
        product.previousRevenue = Number(_.get(removed, 'offerPrice.price', 0))
          .toFixed(2)
          .toString();
        product.quantity = '1';
      }
    }
    return product;
  }

  function constructEcommercePayload(payload, profile) {
    if (!_.isEmpty(profile)) {
      var obj = {
        ecommerce: {
          products: '',
          transactionID: _.get(profile, 'orderID', ''),
          currency: 'CAD',
          tax: Number(_.get(profile, 'monthlyFees.tax', '0.00'))
            .toFixed(2)
            .toString(),
          province: _.get(profile, 'billingAddress.province', '').toLowerCase(),
          postal: _.get(profile, 'billingAddress.postalCode', ''),
          fulfillmentMethod: 'self-serve',
          paymentMethods: [_.get(profile, 'billingPreference.paymentType', '')],
          fees: [
            {
              type: 'one time fee',
              amount: Number(_.get(profile, 'packageAdded.products.offers.additionalPrice.price', '0.00'))
                .toFixed(2)
                .toString()
            }
          ]
        }
      };
      _.merge(payload, obj);
    }
  }

  function constructProductsPayload(payload, product) {
    var products = [];
    products.push(product);
    var obj = {
      ecommerce: {
        products: ''
      }
    };
    obj.ecommerce.products = products;
    _.merge(payload, obj);
  }

  function getExistingPackageSku(packages) {
    var sku = '';
    packages.forEach(function(pkg) {
      pkg.products.forEach(function(product) {
        product.offers.forEach(function(offer) {
          if (offer.isCurrent) sku = offer.offerId;
        });
      });
    });
    updateSessionStorage('__adl', { existingPackage: sku });
    return sku;
  }

  function parseAddress(add) {
    var parsed = {};
    add.split('&').forEach(function(el) {
      var kv = el.split('=');
      parsed[kv[0]] = kv[1].split('+').join(' ');
    });
    return parsed;
  }

  function isInternetFlow(state) {
    var states = [
      'internet',
      'cartSummary',
      'createUser',
      'creditCheck',
      'shipToAddress',
      'pickupAtStore',
      'techInstall',
      'takeItWithYou',
      'paymentOptions',
      'review',
      'confirmation',
      'order-review',
      'confirm',
      'myAccount.internet.package.change.review'
    ];
    return states.indexOf(state) > -1;
  }

  function getSessionStorage(key, path) {
    return _.get(JSON.parse(sessionStorage.getItem(key)), path, '');
  }
})();
